<template>
  <div class="mic-container">
    <div class="circle" :class="{ 'active': active }" @click="recording">
      <i class="fas fa-microphone"></i>
    </div>

    <div id="audio-container" class="holder trash-container" hidden>
      <audio ref="audioPlayer" controls style="display: none; margin-right: 10px;"></audio>
      <div id="trash" class="trash-container">
        <button id="trash-button" class="btn btn-danger" @click.stop="removeAudioPlayer">
          <i class="fas fa-trash"></i>
        </button>
      </div>

      <div id="send" class="send-container">
        <button id="send-button" class="btn btn-success" @click="sendAudioOnButtonClick">
          <i class="fa-solid fa-paper-plane"></i>
        </button>
      </div>

      <div data-role="recordings"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Recorder from 'recorder-js';

export default {
  data() {
    return {
      active: false,
      showAudioPlayer: true,
      audioBlob: null,
      recorder: null,
      audioContext: null,
      stream: null,
    };
  },
  props: {
    queueMessage: Boolean,
  },
  methods: {
    ...mapActions(["sendAudio"]),

    async recording() {
      this.active = !this.active;

      if (this.active) {
        await this.start();
      } else {
        await this.stop();
      }
    },

    async start() {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
      this.recorder = new Recorder(this.audioContext);

      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        await this.recorder.init(this.stream);
        this.recorder.start();
      } catch (error) {
        console.error('Erro ao iniciar a gravação:', error);
      }
    },

    async stop() {
      try {
        const { blob } = await this.recorder.stop();

        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
        }

        this.audioBlob = blob;

        const audioUrl = URL.createObjectURL(blob);
        const audioPlayerElement = this.$refs.audioPlayer;
        audioPlayerElement.src = audioUrl;
        audioPlayerElement.style.display = this.showAudioPlayer ? "block" : "none";

        const audioElement = document.getElementById('audio-container');
        if (audioElement) audioElement.removeAttribute('hidden');

      } catch (error) {
        console.error('Erro ao parar a gravação:', error);
      }
    },

    sendAudioOnButtonClick() {
      if (this.audioBlob) {
        this.sendAudio({ blob: this.audioBlob, queueMessage: this.queueMessage });

        this.audioBlob = null;
        this.hideButtons();
        this.removeAudioPlayer();
      }
    },

    removeAudioPlayer() {
      const audioPlayerElement = this.$refs.audioPlayer;
      audioPlayerElement.style.display = 'none';
      this.hideButtons();
    },

    hideButtons() {
      const audioElement = document.getElementById('audio-container');
      if (audioElement) audioElement.setAttribute('hidden', true);
    }
  }
};
</script>

<style scoped>
body {
  overflow: hidden;
}

.trash-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1em;
}

.trash-container .circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  transition: 0.5s;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
}

.trash-container .circle i {
  color: #b2b1b1;
  font-size: 23px;
  transition: 0.9s;
}

.trash-container .circle:before {
  content: '';
  width: 40px;
  height: 40px;
  border-radius: 50%;
  opacity: 0.2;
  z-index: -1;
  position: absolute;
}

.mic-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1em;
}

.mic-container .circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
}

.mic-container .circle i {
  color: #b2b1b1;
  font-size: 23px;
  transition: 0.9s;
}

.mic-container .circle:before {
  content: '';
  width: 40px;
  height: 40px;
  border-radius: 50%;
  opacity: 0.2;
  z-index: -1;
  position: absolute;
}

.mic-container .circle.active {
  background: #ff0000;
}

.mic-container .circle.active:before {
  background: gray;
  animation: bounce 0.8s ease-in-out infinite 0.5s;
}

.mic-container .circle.active i {
  color: #ffffff;
}

.holder {
  display: flex;
  margin-left: 10px;
}

#trash-button {
  color: white;
  background-color: #1c869a;
  border-radius: 20px !important;
  border: transparent;
  padding: 0px 10px;
  height: 35px;
  align-self: center;
  background-color: #dc3545;
  transition: background-color 0.3s ease;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 3px 5px -1px rgb(0 0 0 / 20%);
}

#trash-button:hover {
  color: white;
  background-color: #c82333;
  transition: 0.3s;
}

#send-button {
  color: white;
  border-radius: 20px !important;
  border: transparent;
  padding: 0px 10px;
  height: 35px;
  align-self: center;
  background-color: #28a745;
  transition: background-color 0.3s ease;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 3px 5px -1px rgb(0 0 0 / 20%);
}

#send-button:hover {
  color: white;
  background-color: #218838;
  transition: 0.3s;
}

.send-container {
  margin-left: -10px;
}

.trash-container {
  margin-left: 10px;
}

.trash-container .circle-send {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: green;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  transition: 0.5s;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
}

.trash-container .circle-send i {
  color: #b2b1b1;
  font-size: 23px;
  transition: 0.9s;
}

.trash-container .circle-send:before {
  content: '';
  width: 40px;
  height: 40px;
  border-radius: 50%;
  opacity: 0.2;
  z-index: -1;
  position: absolute;
}

@keyframes bounce {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.4);
  }

  75% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.3);
  }
}
</style>